import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';

const Circular = () => (
  <Box display='flex' height={250}>
    <Box m='auto'>
      <CircularProgress />
    </Box>
  </Box>
);

const Loading = ({ loading = true, children }) => {
  if (loading) {
    return <Circular />;
  }
  return <>{children}</>;
};

export default Loading;
